"use strict";

exports.__esModule = true;
exports.pxToRem = void 0;

const pxToRem = (size, htmlFontSize = 16) => `${size / htmlFontSize}rem`;

exports.pxToRem = pxToRem;